module.exports = __webpack_public_path__ + "img/button-b-patient-02-gordon.f5760e87.png";